module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar barra-governo-fix",
    class: _vm.navbarFixed,
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {
    staticClass: "container hack-tablet"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isMobile || _vm.isScroll) ? _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'Index'
      },
      "title": "Ir para a página inicial"
    }
  }, [_c('div', {
    staticClass: "logo"
  })]) : _vm._e()], 1), _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "id": "menu",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-controls": "navbar",
      "aria-expanded": "false",
      "aria-label": "Menu do Site"
    },
    on: {
      "click": _vm.toggleMenuButton
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu de navegação")]), _c('i', {
    staticClass: "fa fa-bars fa-lg icon"
  })])], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isOpen || !_vm.isMobile) ? _c('div', {
    staticClass: "navbar-collapse",
    class: _vm.navbarStates,
    attrs: {
      "id": "navbar",
      "aria-expanded": "false"
    }
  }, [_c('ul', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.watchMenu),
      expression: "watchMenu"
    }],
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: _vm.dropdownStates
  }, [_c('a', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropdown),
      expression: "closeDropdown"
    }],
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDropdown($event)
      }
    }
  }, [_vm._v("Institucional")]), (_vm.isActiveDropdown) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'apresentacao'
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Apresentação")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'acoes'
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Ações")])], 1), _c('li', [_c('a', {
    attrs: {
      "href": "https://calendar.google.com/calendar/embed?src=proadufrn%40gmail.com&ctz=America%2FFortaleza",
      "target": "_blank"
    }
  }, [_vm._v("Agenda Administrativa")])]), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'equipe'
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Equipe")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'organograma'
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Organograma")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Unidades'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Unidades")])], 1)]) : _vm._e()]), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Noticias'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Notícias")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Categorias'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Documentos")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Galeria'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Galeria")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contato'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Fale Conosco")])], 1), _c('li', {
    staticClass: "divider hidden-md hidden-lg",
    attrs: {
      "role": "separator"
    }
  }), _c('li', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Busca'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Busca")])], 1), _c('li', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sitemap'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Mapa do Site")])], 1)])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea4d47f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/layouts/PageNavbar.vue
// module id = 523
// module chunks = 0